export default {
  SET_NEWS_ITEMS: 'SET_NEWS_ITEMS',
  APPEND_NEWS_ITEMS: 'APPEND_NEWS_ITEMS',
  SET_CURRENT_NEWS_ITEM: 'SET_CURRENT_NEWS_ITEM',
  SET_LOADING: 'SET_LOADING',
  GET_NEWS_ITEMS: 'GET_NEWS_ITEMS',
  GET_NEWS_ITEM: 'GET_NEWS_ITEM',
};
